import React, {Fragment} from "react";
import {NavLink} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import ContextMenu from "../Utils/ContextMenu";
import classes from "./styles.module.css";

function TableRow({data, project}) {
    return (
        <Fragment>
            <tr className={classes.Row}>
                <td>{(data && data.name) || ""}</td>
                <td>{(data && data.date) || ""}</td>
                <td>{project && project.displayName ? project.displayName : (data && data.merchantId) || ""}</td>
                <td>{(data && data.psaCount) || 0}</td>
                <td>{(data && data.psaProcessingCount) || 0}</td>
                <td className={classes.CellMenu}>
                    <ContextMenu icon="menu">
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.ActivateLink}
                                         to={`/metal/contract/${(data && data.id) || ""}/pca/create`}>
                                    <FormattedMessage id="ContractsTable.menu.newPSA"
                                                      defaultMessage="Новый ПСА для контракта"/>
                                </NavLink>
                            </li>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.defaultLink}
                                         to={`/metal/pca?psaContractId=${(data && data.id) || ""}`}>
                                    <FormattedMessage id="ContractsTable.menu.psaList" defaultMessage="Список ПСА"/>
                                </NavLink>
                            </li>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.defaultLink}
                                         to={`/metal/contract/${(data && data.id) || ""}`}>
                                    <FormattedMessage id="ContractsTable.menu.edit" defaultMessage="Редактирование"/>
                                </NavLink>
                            </li>
                        </ul>
                    </ContextMenu>
                </td>
            </tr>
        </Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/ContractsTable/TableRow.js